const PATHS = {
  merchantLogo: {
    default: '/store/content/reward/merchant/logo',
    thumbnail: '/store/content/reward/merchant/logo/thumbnail',
    original: '/store/content/reward/merchant/logo/original',
  },
  merchantBanner: {
    default: '/store/content/reward/merchant/banner/large',
    thumbnail: '/store/content/reward/merchant/banner/thumbnail',
    original: '/store/content/reward/merchant/banner/original',
  },
  merchantBrc: {
    default: '/store/content/reward/merchant/brc',
    original: '/store/content/reward/merchant/brc/original',
  },
  rewardCoverWeb: {
    default: '/store/content/reward/coupon/rewardCoverWeb',
    original: '/store/content/reward/coupon/rewardCoverWeb/original',
  },
  couponCover: {
    default: '/store/content/reward/coupon/cover',
    thumbnail: '/store/content/reward/coupon/cover/thumbnail',
    original: '/store/content/reward/coupon/cover/original',
  },
  couponImages: {
    default: '/store/content/reward/coupon/images',
    thumbnail: '/store/content/reward/coupon/images/thumbnail',
    original: '/store/content/reward/coupon/images/original',
  },
  couponContentImages: {
    default: '/store/content/reward/coupon/content',
  },
  statement: {
    default: '/store/content/reward/record/content/statement',
  },
  merchantImages: {
    default: '/store/content/reward/merchant/images',
    original: '/store/content/reward/merchant/images/original',
  },
};

export default (value, type, key = 'default', requireTimestamp = true, t = null) => {
  if (!value) return null;
  if (!PATHS[type]) return null;

  const path = PATHS[type][key] || PATHS[type].default;
  if (!path) return null;

  const image = `${path}/${value}`;
  if (!requireTimestamp) return image;

  const timestamp = t || new Date().getTime();
  return `${image}?t=${timestamp}`;
};
